import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  popupVisible: true,
  modalDate: null,
};

// Slice
const popUpSliderSlice = createSlice({
  name: "popUpSlider",
  initialState,
  reducers: {
    setPopupVisible(state, action) {
      const { popupVisible } = action.payload;
      return { ...state, popupVisible };
    },
    setModalDate(state, action) {
      const { modalDate } = action.payload;
      return { ...state, modalDate };
    },
  },
});

export const { setPopupVisible, setModalDate } = popUpSliderSlice.actions;

export default popUpSliderSlice.reducer;
